<template>
    <div class="search-box position-relative" v-click-outside="hidePopup">
        <i class="fas fa-search mr-2" style="color: gray"></i>
        <input type="text" class="search-input" :placeholder="placeholder" autocomplete="off" v-model.trim="keyword" v-on:keyup.enter="quickSearch(this.$constant.TYPE_SRC_ORDER_SUPPLIER)"/>
        <div class="d-inline-flex" v-click-outside="closeDropDownSearch">
            <button type="button" id="idDropdownBtnSearch" class="border-none bg-transparent btn-icon" @click="showDropDownSearch()" v-if="!promotionSearch"><i class="fas fa-caret-down"></i></button>
            <div id="idDropdownMenuSearch" class="dropdown-content" v-show="showDropDown">
                <div class="form-group p-0 mx-2 mb-1">
                    <input type="text" v-model.trim="keyword" autocomplete="off" class="form-control pl-0 border-bottom input-quick-search" :placeholder="$t('message.InputQuickSearch.placeholder.purchase_order')"
                    v-on:keyup.enter="quickSearch(this.$constant.TYPE_SRC_ORDER_SUPPLIER)">
                </div>
                <div class="form-group p-0 mx-2 mb-1">
                    <input type="text" v-model.trim="product_code" autocomplete="off" class="form-control pl-0 border-bottom input-quick-search" :placeholder="$t('message.InputQuickSearch.placeholder.product_code_name')"
                    v-on:keyup.enter="quickSearch($constant.TYPE_SRC_RETURN_IMPORT_SUPPLIER)">
                </div>
            </div>
        </div>
        <div class="popup-product-search" v-if="keyword">
            <ul class="wrap-products" v-if="imports?.length">
                <li v-for="item in imports" :key="item.id" @click="onSelect(item, this.$constant.TYPE_SRC_ORDER_SUPPLIER)">
                    <div class="product-info d-flex justify-content-between">
                        <p class="name-item">
                            <span>{{ item.code }}</span>
                        </p>
                        <p>
                            <span class="price-label">{{$t('message.common.createdAt')}}: </span>
                            <span class="price-value">{{ item.importDate }}</span>
                        </p>
                    </div>
                </li>
            </ul>
            <div v-else class="products-not-found">
                <span>
                    {{$t('message.common.notFound')}}
                </span>
            </div>
        </div>

        <div v-else>
            <div class="popup-product-search" v-if="product_code">
                          <ul class="wrap-products" v-if="products?.length">
                            <li v-for="product in products" :key="product.id" @click="onSelect(product, $constant.TYPE_SRC_RETURN_IMPORT_SUPPLIER)">
                                <template v-if="product.image?.length > 0">
                                    <div class="product-img" v-if="!this.searchMedicine">
                                        <img v-if="product.image" :src="product.image[0]?.url" alt="" class="detail-row-img">
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="product-img" v-if="!this.searchMedicine">
                                        <img src="../../public/img/default-product.png" alt="" class="detail-row-img">
                                    </div>
                                </template>
                                <div class="product-info">
                                    <p class="name-item" >
                                        <span v-text="product.productName ? product.productName : (product.name? product.name : null)"></span>
                                    </p>
                                    <p>
                                        <span class="price-label">{{ product.productCode ? product.productCode : (product.code? product.code : null) }}</span>
                                        <span v-if="!this.searchMedicine" class="price-label ml-2">{{$t('message.ProductUnitSearch.price')}}: {{ n(product.price) }}</span>
                                        <span v-if="!this.searchMedicine" class="price-label ml-1">{{$t('message.ProductUnitSearch.inventory')}}: {{ n(product.inventories) }}</span>
                                    </p>
                                    <p v-if="!this.searchMedicine">
                                        <span class="price-label">{{$t('message.ProductUnitSearch.orderFromCustomer')}}: {{ n(product.quantityOrder) }}</span>
                                        <span class="price-label ml-1"> {{$t('message.ProductUnitSearch.orderSupplier')}}: {{ n(product.quantityOrderSupplier) }}</span>
                                    </p>
                                </div>
                            </li>
                        </ul>
            <div v-else class="products-not-found">
                <span>
                    {{ $t('message.common.notFound') }}
                </span>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {$alert, $get, debounce, $post, TYPE_IMPORT, TYPE_EXPORT, TYPE_TRANSFER,} from "@/lib/utils";
    import store from "@/store";
    let app;

    export default {
        name: "MultipleSearchReturn",
        emits: ['select'],
        props: ['placeholder', 'type', 'currentTab'],
        data() {
            app = this;
            return {
                entries: [],
                keyword: '',
                showDropDown: false,
                search: false,
                settlement_advance_code: '',
                return_purchase_code: '',
                order_supplier_code: '',
                typeSrc: null,
                TYPE_IMPORT, TYPE_EXPORT, TYPE_TRANSFER,
                imports: [],
                products: [],
                product_code: '',
            }
        },
        methods: {
            // onSearchInvoice: debounce(async () => {
            //     app.entries.length = 0;

            //     if (!app.keyword) {
            //         return true;
            //     }
            //     let res = null;
            //     if(app.type === app.TYPE_IMPORT){
            //         res = await $post('/v1/ticket-import/get-lists', {code: app.keyword, record: 15, page: 1, branchId: store.state.CurrentBranch.id});
            //     }
            //     if(app.type === app.TYPE_EXPORT){
            //         res = await $post('/v1/ticket-export/get-lists', {code: app.keyword, record: 15, page: 1, branchId: store.state.CurrentBranch.id});
            //     }
            //     if(res){
            //         if (res.result.code !== 200) {
            //             $alert(res);
            //             return;
            //         }
            //         app.entries = res.result.data.entries;
            //     }
            // }),
            onSelect(entry, type) {
                entry.typeSrc = this.typeSrc;
                this.$emit('select', {entry: entry , type:type});
                this.hidePopup();
                
            },
            hidePopup() {
                this.keyword = '';
                this.product_code = '';
                this.entries.length = 0;
                this.search = false;
                this.imports = this.products = [];
            },
            closeDropDownSearch(){
                this.showDropDown = false;
            },
            showDropDownSearch(){
                this.showDropDown = !this.showDropDown;
                this.keyword = this.product_code = '';
            },
            async quickSearch(type){
                if (type == this.$constant.TYPE_SRC_RETURN_IMPORT_SUPPLIER) {
                    this.keyword = '';
                    if (this.product_code && this.product_code.length >= 3) {
                        const res = await $get('/v1/products/get-product-units', {
                            keyword: this.product_code,
                            branchId: store.state.CurrentBranch.id,
                        });
                        this.products = res;
                    }
                } else {
                    this.product_code = '';
                    const res = await $get('/v1/order-suppliers/get-imports-supplier', {
                        keyword: this.keyword,
                        branchId: store.state.CurrentBranch.id,
                    });
                    if (res.status.code == 200) {
                        this.imports = res.result;
                    } else {
                        $alert(res);
                    }
                }
                
                this.closeDropDownSearch();
            }
        }
    }
</script>

<style scoped lang="scss">
@import "../assets/css/vars.scss";
    .btn-icon:focus{
        outline: none;
        border: none;
    }
    .dropdown-content{
        z-index: 999;
        margin: 0.5rem 0 0;
        width: 100%;
        background-color: #fff;
        padding: 0.5rem;
        border: none;
        background-color: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        -webkit-box-shadow: 0 5px 25px rgb(0 0 0 / 25%);
        -moz-box-shadow: 0 5px 25px rgba(0,0,0,.25);
        box-shadow: 0 5px 25px rgb(0 0 0 / 25%);
        transform: translate3d(0px, 28px, 0px) !important;

        position: absolute;
        left: 0;
        top: 0;
        float: left;
        min-width: 10rem;
        color: #212529;
        text-align: left;
        list-style: none;
        background-clip: padding-box;
    }
    .input-quick-search:focus{
        border-bottom: 1px solid $base-color !important;
        border-radius: 0;
    }
    .popup-product-search {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        min-width: 450px;
        z-index: 10;
        padding-bottom: 20px;
        /*padding-bottom: 50px;*/

        max-height: calc(100vh - 230px);
        font-size: 14px;
        background: #fff;

        border-radius: 5px;
        box-shadow: 0 5px 15px rgb(0 0 0 / 35%);

        ul.wrap-invoices {
            padding: 10px 0;
            overflow: auto;
            max-height: calc(100vh - 284px);
            list-style: none;
            margin-bottom: 0;

            li {
                cursor: pointer;
                padding: 10px 20px;
                margin: 0;

                .product-img {
                    width: 55px;
                    height: 55px;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    float: left;
                    margin-left: -5px;
                    margin-top: 0;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        vertical-align: middle;
                    }
                }

                .product-info {
                    margin-left: 60px;
                    line-height: 18px;

                    p {
                        margin-bottom: 2px;
                    }

                    .name-item {
                        font-weight: bold;
                        word-break: break-word;
                    }

                    .code-item, .price-item {
                        margin-right: 20px;
                        margin-left: 0;
                    }
                }
            }

            li:hover {
                background-color: $base-color;
                color: #fff;
            }

            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }

            &::-webkit-scrollbar-thumb {
                width: 8px;
                border-radius: 4px;
                background-color: #c1c1c1;
                border: 1px solid #fff;
            }

            &::-webkit-scrollbar-track {
                padding: 6px;
            }
        }

        .invoices-not-found {
            padding: 25px 10px;
            color: #999999;
            text-align: center;
        }

        .add-new-product {
            line-height: 50px;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            text-align: center;
            border-top: 1px solid #ebebeb;
            cursor: pointer;

            &:hover {
                background-color: $base-color;
                color: #fff;
            }
        }
    }
    .search-input[readonly]{
        background-color: transparent !important;
        cursor: pointer;
        pointer-events: all !important;
    }
</style>
